import { formatBRL } from '../agenda/cliente/List/helpers';
import { formatQuantity } from '../estoque/units';

export function SaleItemsGroup({ items = [] }: { items?: any[] }) {
    return (
        <ul className="sf-group">
            {items.map((item, index) => {
                const quantity = Number(item?.quantity || 0);
                const unitPrice = Number(item?.unitPrice || 0);

                return (
                    <li key={`${item?.itemId || 'item'}-${index}`}>
                        <div className="sf-row">
                            <span className="sf-row-body">
                                <span className="sf-row-title">{item?.name || 'Item'}</span>
                                <span className="sf-row-sub">
                                    {formatQuantity(quantity)} × {formatBRL(unitPrice)}
                                    {!!item?.sku && ` · ${item.sku}`}
                                </span>
                            </span>
                            <span className="sf-row-end">{formatBRL(item?.lineTotal ?? quantity * unitPrice)}</span>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}

export function SaleTotals({
    subTotal,
    discountAmount,
    discountRule,
    total,
}: {
    subTotal: number;
    discountAmount: number;
    discountRule?: string;
    total: number;
}) {
    return (
        <div className="sf-group">
            <div className="sf-info-row">
                <span>Subtotal</span>
                <span>{formatBRL(subTotal)}</span>
            </div>
            {discountAmount > 0 && (
                <div className="sf-info-row">
                    <span>Desconto{discountRule ? ` (${discountRule})` : ''}</span>
                    <span>− {formatBRL(discountAmount)}</span>
                </div>
            )}
            <div className="sf-info-row font-semibold">
                <span>Total</span>
                <span className="!text-base-content">{formatBRL(total)}</span>
            </div>
        </div>
    );
}
